"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var Icon_1 = require("../Icon");
var TreeNode = (function (_super) {
    __extends(TreeNode, _super);
    function TreeNode() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.nodeExpanded = function (e) {
            e.stopPropagation();
            e.preventDefault();
            _this.props.nodeExpanded();
        };
        _this.nodeSelected = function () {
            _this.props.nodeSelected();
        };
        return _this;
    }
    TreeNode.prototype.render = function () {
        var styleObj = {
            marginLeft: (this.props.itemDepth) * 20
        };
        var nodeClasses = classNames({
            CommonUXTreeNode: true,
            CommonUXTreeLeafNode: this.props.isLeafNode,
            CommonUXSelectedTreeNode: this.props.isSelected
        });
        var arrowClass = this.props.isExpanded ? 'ExpanderTriangleDown' : undefined;
        var arrowContainer = (React.createElement("div", { className: 'CommonUXTreeExpanderTriangleContainer', onClick: this.nodeExpanded },
            React.createElement(ExpanderTriangle, { className: classNames('ExpanderTriangle', arrowClass) })));
        return (React.createElement("li", { id: "node" + this.props.id, className: nodeClasses, key: this.props.index, style: styleObj, onClick: this.nodeSelected },
            this.props.isLeafNode ? undefined : arrowContainer,
            this.props.nodeIcon ? React.createElement(Icon_1.Icon, { color: '#2E92FA', icon: this.props.nodeIcon, size: 'small' }) : undefined,
            React.createElement("span", { style: { marginLeft: '6px' } }, this.props.nodeText)));
    };
    return TreeNode;
}(React.Component));
exports.TreeNode = TreeNode;
var ExpanderTriangle = (function (_super) {
    __extends(ExpanderTriangle, _super);
    function ExpanderTriangle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExpanderTriangle.prototype.render = function () {
        return (React.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', className: this.props.className, width: '16', height: '16', viewBox: '0 0 16 16' },
            React.createElement("title", null, "Expand"),
            React.createElement("polygon", { points: '6 5 6 11 11 8 6 5' })));
    };
    return ExpanderTriangle;
}(React.Component));
//# sourceMappingURL=TreeNode.js.map